// extracted by mini-css-extract-plugin
export default {"paragraph":"uqr0kVhU","large":"DNtD5dXg","small":"ZAggLcZE","small-display":"CxAon5Hl","xsmall":"EphAtrqg","semi-bold":"Ut3WhkWD"};